// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionPerfect_wrapper__WtQCP","item":"SectionPerfect_item__WUlI0","item__icon":"SectionPerfect_item__icon___S_Nf","item__label":"SectionPerfect_item__label__fflfu"};